var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('QIcon',{class:{ 'cursor-pointer': !_vm.disabled },attrs:{"name":_vm.minusIcon,"size":"sm","outline":"","round":"","disable":_vm.disabled,"color":_vm.disabled ? 'grey-5' : 'secondary'},on:{"click":_vm.emit}})}
var staticRenderFns = []

export { render, staticRenderFns }